import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useSetState from 'hooks/useSetState'
import useOutsideClick from 'hooks/useOutsideClick'

import styles from './styles.scss'

const defaultState = {
  showMenu: false,
}

const renderMenu = (props, state, ref, setState, closeOnClick) => {
  const { showMenu } = state
  const { children, listStyle, nibStyle } = props

  if (!children.length){
    return (
      <div onClick={closeOnClick ? () => setState({ showMenu: false }) : null}>
        <ul className={showMenu ? styles.menu : styles.hidden} ref={ref} style={listStyle}>
          <div className={styles.nib} style={nibStyle} />
          <li>{children}</li>
        </ul>
      </div>
    )
  }

  return (
    <div onClick={closeOnClick ? () => setState({ showMenu: false }) : null}>
      <ul className={showMenu ? styles.menu : styles.hidden} ref={ref} style={listStyle}>
        <div className={styles.nib} style={nibStyle} />
        {children.map(child => child && <li key={child.key}>{child}</li>)}
      </ul>
    </div>
  )
}

const IconWithMenu = (props) => {
  const {
    buttonStyle, className, closeOnClick, dataTestId, icon, style,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { showMenu } = state

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showMenu })

  useEffect(() => {
    if (isClickedOutside && showMenu){
      setState({ showMenu: false })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  return (
    <div className={classnames(className, styles.root)} data-test-id={dataTestId} style={style}>
      <a className={styles.icon} tabIndex="0" onClick={() => setState({ showMenu: !showMenu })} style={buttonStyle}>
        {icon}
      </a>
      {showMenu && renderMenu(props, state, contentEl, setState, closeOnClick)}
    </div>
  )
}

IconWithMenu.propTypes = {
  buttonStyle: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  closeOnClick: PropTypes.bool,
  dataTestId: PropTypes.string,
  icon: PropTypes.node,
  listStyle: PropTypes.object,
  nibStyle: PropTypes.object,
  style: PropTypes.object,
}

IconWithMenu.defaultProps = {
  closeOnClick: false,
}

export default IconWithMenu
